import React, { 
    useState, 
    useEffect, 
    useMemo, 
    useContext, 
} from 'react';
import { Button } from '@/shared/components/Button';
import PropTypes from 'prop-types';
import RestaurantLocation from './RestaurantLocation';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../context/AuthContext';
import { RestaurantContext } from '../../../../context/RestaurantContext';
import { DashboardContext } from '../../../../context/DashboardContext';
import Loader from '../../Meal/component/Loader';



const LocationDetails = ({ restaurantDetailsId, refresh }) => {
    const { apiGlobal } = useContext(GlobalVarContext);
    const { userid, countryId } = useContext(AuthContext);
     const { LocationRefesh } = useContext(RestaurantContext);
    const [locationDetails, setLocationDetails] = useState([]);
    const [status, setStatus] = useState({ isLoading: true, error: null });
    const { setRestaurantlocation } = useContext(DashboardContext);

  if (!userid) {
       console.log('No user id found');
  }
  // console.log(restaurantDetailsId);
  // console.log(userid);


  useEffect(() => {
    if (!restaurantDetailsId) return;

    const fetchLocationDetails = async () => {
      const formData = new FormData();
      formData.append('id', restaurantDetailsId);
      formData.append('user_id', userid);
      formData.append('country_id', countryId);
      try {
        setStatus({ isLoading: true, error: null });
        
        const response = await fetch(`${apiGlobal}/restaurant/restaurant_details_fetch.php`, {
            method: 'POST',
            body: formData,
          });

        if (!response.ok) {
          throw new Error('Failed to fetch location details');
        }

        const data = await response.json();
        // console.log(data);
        if (!data?.data?.length) {
          throw new Error('No location data found');
        }

        setLocationDetails(data?.data);
        // console.log(data?.data.length);
        setRestaurantlocation(data?.data.length);
      } catch (err) {
        setStatus({ isLoading: false, error: err.message });
      } finally {
        setStatus(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchLocationDetails();
  }, [restaurantDetailsId, refresh, LocationRefesh]);

  const derivedStatus = useMemo(() => {
    if (status.isLoading) return { message: <Loader />, type: 'loading' };
    if (status.error) return { message: 'No Location Found', type: 'error' };
    if (!locationDetails.length) return { message: 'No location data available', type: 'empty' };
    return { type: 'success' };
  }, [status, locationDetails]);

  const styles = {
    header: {
      color: 'black',
      marginLeft: '10px',
      marginBottom: '5px',
    },
  };

  if (derivedStatus.type !== 'success') {
    return <div>{derivedStatus.message}</div>;
  }

  // return (
  //   <div>
  //     <div style={{ display: 'flex' }}>
  //       <h2 style={styles.header}>Restaurant Locations</h2>
  //     </div>
      
  //     {locationDetails.map(location => (
  //       <RestaurantLocation key={location.id} alldetails={location} />
  //     ))}
  //   </div>
  // );
  return (

    <div style={{ height: '93%' }}>
      <div style={{ display: 'flex' }}>
        <h2 style={styles.header}>Restaurant Locations</h2>
      </div>
      <div style={{ height: '600px', overflowY: 'auto', marginTop: '15px' }}>
        {locationDetails.map(location => (
          <RestaurantLocation key={location?.id} alldetails={location} />
        ))}
      </div>
    </div>
  );
};

LocationDetails.propTypes = {
  restaurantDetailsId: PropTypes.string.isRequired,
  refresh: PropTypes.bool.isRequired,
};

export default LocationDetails;
